import { AdminBillingResource } from './resources/billing';
import { AdminDashboardResource } from './resources/dashboard';
import { AdminPromptResource } from './resources/prompt';
import { AdminQuotaResource } from './resources/quota';
import { AdminUserResource } from './resources/user';

export class AdminResource {
  private readonly dashboardResource: AdminDashboardResource;
  private readonly userResource: AdminUserResource;
  private readonly quotaResource: AdminQuotaResource;
  private readonly billingResource: AdminBillingResource;
  private readonly promptResource: AdminPromptResource;

  constructor() {
    this.dashboardResource = new AdminDashboardResource();
    this.userResource = new AdminUserResource();
    this.quotaResource = new AdminQuotaResource();
    this.billingResource = new AdminBillingResource();
    this.promptResource = new AdminPromptResource();
  }

  get dashboard() {
    return this.dashboardResource;
  }

  get user() {
    return this.userResource;
  }

  get quota() {
    return this.quotaResource;
  }

  get billing() {
    return this.billingResource;
  }

  get prompts() {
    return this.promptResource;
  }
}
